<template>
  <div class="stock-out-create">
    <ContentHeader
      path-set-type="append"
      :show-back="true"
      :path-info="navPathInfo"
    />
    <div class="content-container">
      <!-- 条件 -->
      <div class="query-panel">
        <el-form
          ref="stockForm"
          :model="queryParam"
          label-position="right"
          label-width="100px"
          size="small"
          :rules="formRules"
          class="query-form"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="出库单名称" prop="billName">
                <el-input
                  v-model="queryParam.billName"
                  placeholder="请输入出库单名称"
                  class="panel-input"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所在仓库" prop="warehouseId">
                <el-select
                  v-model="queryParam.warehouseId"
                  placeholder="请选择所在仓库"
                  clearable
                >
                  <el-option
                    v-for="option in warehouseList"
                    :key="option.key"
                    :label="option.warehouseName"
                    :value="option.warehouseId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="出库时间" prop="stockOutTime">
                <el-date-picker
                  v-model="queryParam.stockOutTime"
                  type="date"
                  placeholder="请选择出库时间"
                  value-format="yyyy-MM-dd"
                  class="form-date-item"
                  clearable
                  :picker-options="pickerOptionsStart"
                />
              </el-form-item>
            </el-col>
            <el-col :span="23">
              <el-form-item label="备注">
                <el-input
                  :rows="2"
                  type="textarea"
                  v-model="queryParam.remark"
                  placeholder="请输入备注"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="errorList.length" class="error">
            <el-col :offset="2" :span="16">
              <p v-for="(error, index) in errorList" :key="index">
                {{ error }}
              </p>
            </el-col>
          </el-row>
        </el-form>

        <div class="btn-line">
          <el-button class="btn-blue-plain template-btn">
            <i class="iconfont iconzu22" />
            <a target="_blank" @click="getTemplate">下载模板文件</a>
          </el-button>
          <div class="upload">
            <FileUpload
              ref="dataFileUpload"
              :upload-param="{ filePath: 'temp' }"
              show-type="text"
              @uploaded="getDataFile"
              @removed="clearDataFile"
            >
              <el-button class="btn-blue-plain template-btn" size="small"
                ><i class="iconfont iconzu111" />上传EXCEL文件</el-button
              >
            </FileUpload>
          </div>
          <el-button class="btn-blue-plain" @click="saveForm" size="small" :disabled="canSave?false:true"
            >{{canSave?'提交上传':'上传处理中'}}</el-button
          >
          <el-button class="btn-grey-plain" @click="resetQuery" size="small"
            >重置</el-button
          >
        </div>
      </div>
    </div>
    <v-form ref="form" :url="exportUrl" />
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import FileUpload from '@/components/file-upload'
import { commonUtils } from '@/utils/common'
import vForm from '@/components/v-form'
export default {
  name: 'stock-out-create',
  components: {
    FileUpload,
    ContentHeader,
    vForm
  },
  data () {
    return {
      loading: false,
      pickerOptionsStart: {},
      warehouseList: [],
      formRules: {
        billName: [
          { required: true, message: '请输入出库单名称', trigger: 'blur' }
        ],
        warehouseId: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        stockOutTime: [
          { required: true, message: '请选择出库时间', trigger: 'change' }
        ],
        dataFileId: [
          { required: true, message: '请上传EXCEL文件', trigger: 'change' }
        ]
      },
      errorList: [],
      canSave: true,
      queryParam: {
        billName: '',
        warehouseId: '',
        remark: '',
        dataFileId: '',
        stockOutTime: ''
      },
      exportUrl: null,
    }
  },
  computed: {
    navPathInfo () {
      let pathInfo = { path: '/stock/stock', name: '库存' }
      return [pathInfo]
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getWarehouseList()
    },
    // 重置
    resetQuery () {
      this.errorList = []
      this.queryParam = this.$options.data().queryParam
      this.$refs.dataFileUpload.getClearFiles()
    },
    // 上传文件
    getDataFile (file) {
      this.queryParam.dataFileId = file.fileId
    },
    // 删除模板文件
    clearDataFile () {
      this.errorList = []
      this.queryParam.dataFileId = ''
    },
    // 检查数据
    checkForm () {
      if (!this.queryParam.billName) {
        this.$message.error('请填写出库单名称')
        return false
      }
      if (!this.queryParam.warehouseId) {
        this.$message.error('请选择所在仓库')
        return false
      }
      if (!this.queryParam.stockOutTime) {
        this.$message.error('请选择出库时间')
        return false
      }
      if (!this.queryParam.dataFileId) {
        this.$message.error('请上传EXCEL文件')
        return false
      }
      return true
    },
    // 提交上传
    saveForm () {
      if (!this.checkForm()) {
        return
      }
      this.canSave = false
      this.$store
        .dispatch('stockOrderImport', this.queryParam)
        .then(res => {
          if (res.data.resultCode === '0') {
            this.resetQuery()
            this.$router.push({
              path: '/stock/stock-order-success',
              query: {
                billNumber: res.data.resultData.billNumber,
                moduleType: '01'
              }
            })
          } else if (res.data.resultCode === '01') {
            if (res.data.resultData.errorList) {
              this.errorList = res.data.resultData.errorList
            } else {
              this.$message.error(res.data.resultData.resultMsg)
            }
          }
          this.canSave = true
        })
        .catch(() => {
          this.canSave = true
          this.$message.error('文件上传失败')
        })
    },
    // 获取仓库列表
    getWarehouseList () {
      this.$store.dispatch('getWarehouseLists').then(response => {
        this.warehouseList = response.data.resultData.warehouseList
      })
    },
    getTemplate() {
      this.exportUrl = commonUtils.getApiUrl('/stock/bu-type/export/stock-out-import-template')
      this.$refs.form.submit()
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-line {
  padding: 25px 0;
}
.upload {
  display: inline-block;
  margin: 0 10px;
}
.template {
  text-align: center;
}
.template-btn {
  padding: 7px 15px;
  a {
    color: #2185d0;
    font-size: 12px;
  }
}
.error {
  color:rgb(246, 120, 120);
}
</style>
